import React from 'react';

export default function TermsOfServicePage() {
  return (
    <div style={{ maxWidth: 760, margin: '60px auto', padding: '0 24px 80px', fontFamily: 'inherit', color: '#1a1a1a', lineHeight: 1.7 }}>
      <h1 style={{ fontSize: 28, fontWeight: 700, marginBottom: 4 }}>Terms of Service</h1>
      <p style={{ color: '#888', fontSize: 14, marginBottom: 40 }}>Last updated: May 2026</p>

      <section style={{ marginBottom: 32 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>1. Acceptance of Terms</h2>
        <p>
          By accessing or using eYantra's platform, website, or AI integrations (including the eYantra
          MCP connector), you agree to be bound by these Terms of Service. If you do not agree, please
          do not use our services.
        </p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>2. Services</h2>
        <p>
          eYantra provides a B2B corporate gifting platform that allows businesses to browse products,
          request bulk quotes (RFQs), and place orders for customised, branded merchandise. Our AI
          connector enables these capabilities through third-party AI assistants such as Claude and
          ChatGPT.
        </p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>3. Use of AI Integrations</h2>
        <p>
          The eYantra MCP connector allows AI assistants to search our product catalog and submit quote
          requests on your behalf. By using this integration, you confirm that all information provided
          (name, email, company, product selections) is accurate and that you authorise the submission
          of quote requests to our sales team.
        </p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>4. Quote Requests</h2>
        <p>
          Submitting a quote request (RFQ) does not constitute a binding purchase order. All quotes are
          subject to confirmation by the eYantra sales team. Pricing, availability, and delivery
          timelines are confirmed in the formal quotation sent by email.
        </p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>5. Intellectual Property</h2>
        <p>
          All content on the eYantra platform, including product images, descriptions, and branding, is
          the property of eYantra or its suppliers. You may not reproduce or redistribute any content
          without prior written consent.
        </p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>6. Limitation of Liability</h2>
        <p>
          eYantra shall not be liable for any indirect, incidental, or consequential damages arising
          from the use of our platform or AI integrations. Our total liability shall not exceed the
          value of the order in question.
        </p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>7. Governing Law</h2>
        <p>
          These terms are governed by the laws of India. Any disputes shall be subject to the
          jurisdiction of the courts in Hyderabad, Telangana.
        </p>
      </section>

      <section>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>8. Contact</h2>
        <p>
          For any queries regarding these terms, contact us at{' '}
          <a href="mailto:tech@eyantra.com" style={{ color: '#E05010' }}>tech@eyantra.com</a> or write to:<br />
          eYantra, Hyderabad, India.
        </p>
      </section>
    </div>
  );
}